import React, { useState } from "react";
import { TextInput } from "@sprout/text_input";
import useTranslation from "@hooks/use_translation";
import { PrimaryButton } from "@sprout/buttons";
import { useMediaQuery } from "usehooks-ts";
import classNames from "classnames";
import { router } from "@inertiajs/react";

type EmailFormProps = {
  jobBoardToken: string;
  createPath: string;
  email: string;
  setShowCode: (showCode: boolean) => void;
  setEmail: (email: string) => void;
};

const LoginEmail = (props: EmailFormProps) => {
  const { jobBoardToken, createPath, email, setShowCode, setEmail } = props;
  const { t } = useTranslation("misc");

  const isSmallScreen = useMediaQuery("(max-width: 480px");
  const buttonContainerClassNames = classNames({
    "flex flex-col": isSmallScreen,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const defaultErrorMessage = t("defaultError");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);

    if (!emailRegex.test(email)) {
      setError(t("login.invalidEmail"));
      return;
    }

    setIsSubmitting(true);

    router.post(
      createPath,
      {
        email: email,
        job_board: jobBoardToken,
      },
      {
        onError: (errors) => {
          setError(errors["email"] || errors["_server"] || defaultErrorMessage);
        },
        onFinish: () => setIsSubmitting(false),
        onSuccess: () => setShowCode(true),
      },
    );
  };

  return (
    <form onSubmit={submit}>
      <TextInput
        id="email-address"
        placeholder={t("login.email")}
        type="email"
        required
        onChange={(event) => setEmail(event.currentTarget.value || "")}
        maxLength={255}
        value={email}
        error={error}
        autoFocus
      />

      <div className={buttonContainerClassNames}>
        <PrimaryButton loading={isSubmitting} type="submit">
          {t("login.sendCode")}
        </PrimaryButton>
      </div>
    </form>
  );
};

export default LoginEmail;
